import type { RouteObject } from 'react-router';
import { ImportsPage } from './ImportsPage';
import { ImportDetailPage } from './ImportDetailPage';
import { BatchPage } from './scan/BatchPage';
import { ScanPage } from './scan/ScanPage';

export const routes: RouteObject[] = [
  { path: '/imports', element: <ImportsPage /> },
  { path: '/imports/scan', element: <ScanPage /> },
  { path: '/imports/batch/:batchId', element: <BatchPage /> },
  { path: '/imports/:id', element: <ImportDetailPage /> },
];
